import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField, SelectorInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import React from 'react';
import { useFormState } from 'react-hook-form';

const BrandsTableFilter = () => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Name" {...registerInput(filter, 'display_name')} />
        <TextInputField label="Brand ID" {...registerInput(filter, 'tcr_brand_id')} />
        <SelectorInputField
          label="Status"
          options={[
            { label: 'VERIFIED', value: 'VERIFIED' },
            { label: 'VETTED_VERIFIED', value: 'VETTED_VERIFIED' },
            { label: 'UNVERIFIED', value: 'UNVERIFIED' },
            { label: 'SELF_DECLARED', value: 'SELF_DECLARED' },
            { label: 'All', value: '' },
          ]}
          {...registerInput(filter, 'identity_status')}
        />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default BrandsTableFilter;
